module.exports = __webpack_public_path__ + "media/images/lp/lp13-be9a1470c0fd372a1ca6f92bee077bfe.webp";